import { useStarterDashboardV2PageFcmExperiments } from 'src/app/pages/starterDashboardV2/pageContext';

type UseStarterDashboardV2TabExperiment = ModelHookResult<{
	variant: string;
	isSecondVariant: boolean;
}>;

export function useStarterDashboardTabExperiment(): UseStarterDashboardV2TabExperiment {
	const { dashboardTabsExperiment } = useStarterDashboardV2PageFcmExperiments();

	return {
		data: {
			variant: dashboardTabsExperiment.variation,
			isSecondVariant: dashboardTabsExperiment.variation === 'variant2',
		},
	};
}
